import React from 'react'

export default function AdminHome() {
    return (
        <div style={{ display: "flex", justifyContent: "center" }}>index</div>
    )
}
